export default "__VITE_ASSET__OnF3MnmC__"